(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function swakUnhideSort() {
    // Target only the desktop sort container (not the mobile one)
    const containers = document.querySelectorAll('.sorting-filter__container');
    containers.forEach(el => {
      if (!el.classList.contains('desktop:hidden')) {
        el.removeAttribute('hidden');
        el.style.display = 'block';
      }
    });
  }

  swakUnhideSort();
  setTimeout(swakUnhideSort, 300);
  setTimeout(swakUnhideSort, 800);

  } catch(e) { console.error(e); }
})();
})();
